import {
  Box,
  Button,
  Icon,
  IconButton,
  Link,
  Paper,
  styled,
  TextField,
} from '@worthy-npm/worthy-common-ui-components';
import { motion } from 'framer-motion';
import React from 'react';

const StarInCircleIcon = Icon.createSvgIcon(
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="36" height="36" rx="18" stroke="#2C4EB5" strokeWidth="2" />
    <path
      d="M18.8672 9C19.9425 14.0074 23.862 17.9142 28.8729 18.9731L29 19L28.8729 19.0269C23.862 20.0858 19.9425 23.9926 18.8672 29L18.8399 28.8731C17.78 23.9371 13.9324 20.0765 9 19C13.9324 17.9235 17.78 14.0629 18.8399 9.12691L18.8672 9Z"
      stroke="#2C4EB5"
      strokeWidth="2"
    />
  </svg>,
  'StarInCircleIcon',
);

const FilledStarIcon = Icon.createSvgIcon(
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.8672 1C11.9425 6.00742 15.862 9.9142 20.8729 10.9731L21 11L20.8729 11.0269C15.862 12.0858 11.9425 15.9926 10.8672 21L10.8399 20.8731C9.78 15.9371 5.93237 12.0765 1 11C5.93237 9.92347 9.78 6.06287 10.8399 1.12691L10.8672 1Z"
      fill="#2C4EB5"
      stroke="#2C4EB5"
      strokeWidth="2"
    />
  </svg>,
  'FilledStarIcon',
);

const OutlinedStarIcon = Icon.createSvgIcon(
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.8672 1C11.9425 6.00742 15.862 9.9142 20.8729 10.9731L21 11L20.8729 11.0269C15.862 12.0858 11.9425 15.9926 10.8672 21L10.8399 20.8731C9.78 15.9371 5.93237 12.0765 1 11C5.93237 9.92347 9.78 6.06287 10.8399 1.12691L10.8672 1Z"
      fill="#F2F0EE"
      stroke="#2C4EB5"
      strokeWidth="2"
    />
  </svg>,
  'OutlinedStarIcon',
);

const ArrowR = Icon.createSvgIcon(
  <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.54541 6.5H18M18 6.5C18 6.5 12.1667 4.31818 12.1667 0.5M18 6.5C18 6.5 12.1667 8.68182 12.1667 12.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>,
  'ArrowR',
);

const ClearConversation = Icon.createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.89216 1.55369C4.84654 1.55369 1.55335 4.87004 1.55335 8.97779C1.55335 13.0855 4.84654 16.4019 8.89216 16.4019C9.9554 16.4019 10.964 16.1736 11.8744 15.7635L12.0058 15.7179C13.2489 15.4085 14.5328 15.4194 15.765 15.7744C15.3857 14.5293 15.3372 13.2298 15.6269 11.9628L15.6662 11.8392C16.0297 10.9598 16.231 9.99359 16.231 8.97779C16.231 4.87004 12.9378 1.55369 8.89216 1.55369ZM0 8.97779C0 4.02702 3.97366 0 8.89216 0C13.8107 0 17.7843 4.02702 17.7843 8.97779C17.7843 10.1763 17.5513 11.3218 17.1277 12.3693C16.7959 13.8929 17.0774 15.4887 18 16.9309L16.9211 18C15.5252 17.0882 13.9567 16.8511 12.4452 17.21C11.3562 17.6898 10.154 17.9556 8.89216 17.9556C3.97366 17.9556 0 13.9286 0 8.97779ZM8.28455 8.28637V4.92003H9.83791V8.28637H13.2035V9.84006H9.83791V13.2064H8.28455V9.84006H4.91895V8.28637H8.28455Z"
      fill="#2C4EB5"
    />
  </svg>,
  'ClearConversation',
);

const Header = styled(motion.div)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  width: '100%',
  padding: '24px',
  boxSizing: 'border-box',
  textAlign: 'center',

  [theme.breakpoints.down('md')]: {
    paddingBottom: '14px',
  },
}));

const BackButtonWrapper = styled(IconButton)(({ theme }) => ({
  color: theme.palette.highlight.main,
  padding: 0,
  transform: 'rotate(90deg)',
  position: 'relative',
  left: `-${theme.spacing(2)}`,
}));

const ChatArea = styled(Paper)({
  overflowY: 'auto',
  padding: 0,
  backgroundColor: 'transparent',
  boxShadow: 'none',
});

const InputContainerChat = styled(Box)({
  position: 'relative',
  width: '100%',
  borderRadius: '8px',
  boxSizing: 'border-box',
});

const ChatBoxContainer = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  backgroundColor: '#E5DEDA',
  borderRadius: '8px',
  padding: '14px 24px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',

  width: '90%',
  maxWidth: '602px',
  height: '85vh',
  maxHeight: '100%',
  minHeight: '300px',
  marginTop: 'auto',
  justifyContent: 'flex-end',

  [theme.breakpoints.down('md')]: {
    backgroundColor: 'inherit',
    height: '100vh',
    maxHeight: '100%',
    padding: '0  0 12px 0',
  },
}));

const ContentWrapper = styled(Box)({
  flex: 1,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

const MessageBubble = styled(Box, {
  shouldForwardProp: (prop) => !['assistant', 'loading'].includes(prop as string),
})<{ assistant: boolean; loading: boolean }>(({ theme, assistant, loading }) => ({
  display: 'inline-block',
  padding: assistant ? '8px 0' : '8px 16px',
  borderRadius: '10px',
  marginBottom: '8px',
  backgroundColor: assistant ? 'transparent' : theme.palette.background.paper,
  maxWidth: '80%',
  wordWrap: 'break-word',
  whiteSpace: 'pre-wrap',
  '.ans-polish, #outlined-star': {
    animation: 'pulsate 1.5s ease-in-out infinite',
    opacity: 0.5,
    '@keyframes pulsate': {
      '0%': {
        opacity: 0.5,
      },
      '50%': {
        opacity: 1,
      },
      '100%': {
        opacity: 0.5,
      },
    },
  },
  ...(loading && {
    '.ans-polish, #outlined-star, #star': {
      animation: 'pulsate 1.5s ease-in-out infinite',
      opacity: 0.5,
      '@keyframes pulsate': {
        '0%': {
          opacity: 0.5,
        },
        '50%': {
          opacity: 1,
        },
        '100%': {
          opacity: 0.5,
        },
      },
    },
  }),

  [theme.breakpoints.down('md')]: {
    '#star': {
      display: 'none',
    },
  },
  [theme.breakpoints.up('md')]: {
    '#outlined-star': {
      display: 'none',
    },
  },
}));

const SendButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: '14px',
  right: '16px',
  minWidth: 'auto',
  width: '50px',
  height: '31px',
  borderRadius: '4px',
  backgroundColor: theme.palette.highlight.main,
  color: '#fff',
  fontWeight: 600,
  padding: 0,
  '&:hover': { backgroundColor: '#115293' },
}));

const ClearButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '3px',
  left: '-22px',
  width: '18px',
  height: '18px',
  [theme.breakpoints.down('md')]: {
    top: 0,
    left: '-15px',
  },
}));

const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => !['initInput'].includes(prop as string),
})<{ initInput: boolean }>(({ initInput }) => ({
  width: '100%',
  height: '100%',
  '& .MuiOutlinedInput-root': {
    paddingLeft: '16px',
    paddingRight: initInput ? '16px' : '65px',
    '& fieldset': { border: 'none' },
  },
}));

const MessageRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'role',
})<{ role: string }>(({ role }) => ({
  display: 'flex',
  justifyContent: role === 'user' ? 'flex-end' : 'flex-start',
}));

const OuterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#F2F0EE',
  alignItems: 'center',
  padding: '24px',
  boxSizing: 'border-box',
  height: '100%',
  gap: 'clamp(0px, 1vh, 80px)',
  [theme.breakpoints.down('md')]: {
    padding: 0,
  },
}));

const InitialInputContainer = styled(motion.div)(({ theme }) => ({
  height: '187px',
  backgroundColor: '#F2F0EE',
  borderRadius: '8px',
  padding: '16px',
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  maxWidth: '586px',
  flexDirection: 'column',
  // marginTop: '80px',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

const NextButton = styled(Button)({
  display: 'flex',
  width: '150px',
  height: '46px',
  borderRadius: '4px',
  padding: '12px 16px',
  margin: '16px auto 0',
  justifyContent: 'center',
});

const DisclaimerWrap = styled(Box)(({ theme }) => ({
  marginTop: 'auto',
  width: '100%',
  maxWidth: '964px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px',
  borderRadius: '8px',
  backgroundColor: '#E5DEDA66',
  marginBottom: '16px',
  [theme.breakpoints.down('md')]: {
    width: '90%',
    paddingLeft: '32px',
  },
}));

const LinkStyle = styled(Link)(({ theme }) => ({
  color: theme.palette.secondary.main,
  textDecoration: 'none',
}));

const BtnWrapper = styled(motion.div)(({ theme }) => ({
  maxWidth: '555px',
  width: '100%',
  display: 'flex',
  marginTop: '34px',
  justifyContent: 'flex-end',

  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
}));

const ContinueBtn = styled(Button)(({ theme }) => ({
  '&.Mui-disabled': {
    color: '#919AA7',
    backgroundColor: theme.palette.divider,
  },
}));

const NewConversationPopup = styled(Box)(({ theme }) => ({
  maxWidth: '328px',
  maxHeight: '178px',
  width: '100%',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  alignItems: 'center',
  border: `1px solid ${theme.palette.background.tertiary}`,
}));

const TitleWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  alignSelf: 'stretch',
}));

const ActionBtnWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

const ActionButton = styled(Button, {
  shouldForwardProp: (prop) => !['deleteAction'].includes(prop as string),
})<{ deleteAction: boolean }>(({ theme, deleteAction }) => ({
  maxWidth: '144px',
  width: '100%',
  ...(deleteAction && {
    backgroundColor: '#ED6855',
  }),
  ...(!deleteAction && {
    color: theme.palette.background.secondary,
    border: `1px solid ${theme.palette.background.secondary}`,
  }),
}));

export {
  ActionButton,
  ActionBtnWrap,
  TitleWrap,
  NewConversationPopup,
  ClearButton,
  ClearConversation,
  ContinueBtn,
  BtnWrapper,
  OutlinedStarIcon,
  FilledStarIcon,
  LinkStyle,
  Header,
  ArrowR,
  DisclaimerWrap,
  ContentWrapper,
  StarInCircleIcon,
  NextButton,
  OuterContainer,
  InitialInputContainer,
  MessageRow,
  ChatBoxContainer,
  ChatArea,
  MessageBubble,
  SendButton,
  StyledTextField,
  InputContainerChat,
  BackButtonWrapper,
};
